// extracted by mini-css-extract-plugin
export default {"sberSdk":"AJDGZ6g6","_hasUserInfo":"RMhb1iPj"};